import { PAGE_URLS } from '../../constants/hrefLinks'
import './style.scss'

function HeaderAppSettings() {

	return (
		<div className="header-app-explore-wrap">
			<div className="header-app-explore-wrap-inner">
				<div className='header-app-header-button-wrap'>
					<img
						src={'/imgs/icons/header/icon-header-back-arrow.svg'}
						className='header-app-header-button-img'
						alt='Back Arrow'
						onClick={() => {
							window.location.replace(`${PAGE_URLS.APP_PROFILE}`)
						}}
					/>
				</div>
				<div className='header-app-header-button-wrap'>
					<div className='header-app-header-label'>Settings</div>
				</div>
				{/* <div 
					className='header-app-header-button-wrap'
					onClick={() => {
						filterButtonClickHandler()
					}}
				>
					<img
						src={'/imgs/icons/explore/icon-explore-filter-button.svg'}
						className='header-app-header-button-img header-app-header-button-img-right'
						alt='Filter Button'
					/>
				</div> */}
			</div>
		</div>
	)
}

export default HeaderAppSettings